var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #445689;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d0f19a;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.54,166.84h103.29c3.63-21.78,7.25-43.54,10.9-65.43h-125.1c3.65,21.89,7.27,43.65,10.9,65.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.24,86.86c.41,2.46.79,4.75,1.18,7.08h127.58c.38-2.46.73-4.74,1.09-7.08H79.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.56,177.94h-69.78c-.18-.6-.35-1.02-.42-1.47-1.39-8.31-2.77-16.62-4.15-24.94-4.4-26.43-8.81-52.87-13.22-79.3-.46-2.78-1.63-3.74-4.48-3.76-4.25-.02-8.51,0-12.76,0-3.93,0-7.85,0-11.83,0v7.34h22.15c.17.54.32.89.38,1.26,1.87,11.23,3.72,22.47,5.59,33.7,3.89,23.36,7.79,46.73,11.71,70.08.62,3.7,1.52,4.39,5.31,4.4,5.13,0,10.27,0,15.51,0-3.49,7.1-2.88,12.27,1.75,15.93,3.96,3.13,9.56,3.13,13.5,0,4.62-3.67,5.23-8.78,1.77-15.94h42.45c1.84,0,3.68,0,5.54,0-3.49,7.1-2.88,12.27,1.75,15.93,3.96,3.13,9.56,3.13,13.5,0,4.62-3.67,5.23-8.78,1.77-15.94h4.31s-.02-.05-.04-.08h15.09v-7.36h-45.38v.12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPurchase);
export default __webpack_public_path__ + "static/media/Big Purchase.61372beeda3b67063f495d601b069e26.svg";
export { ForwardRef as ReactComponent };